export const SIGN_OUT = '@auth/SIGN_OUT';
export const SIGN_OUT_ACCEPTED = '@auth/SIGN_OUT_ACCEPTED';
export const SIGN_OUT_REJECTED = '@auth/SIGN_OUT_REJECTED';

export const signOut = () => ({
    type: SIGN_OUT,
    payload: {},
});

export const acceptSignOut = () => ({
    type: SIGN_OUT_ACCEPTED,
    payload: {},
});

export const rejectSignOut = ({ error }) => ({
    type: SIGN_OUT_REJECTED,
    payload: { error },
});
